/* eslint @typescript-eslint/camelcase: "off" */

import { API_URL } from '@constants';

import { getParametrizedUrl } from '@utils';

import { BaseApi } from '../BaseApi';

import {
	IAlbumsApiFetchAlbumRequestParams,
	IAlbumsApiFetchAlbumResponseData,
	IAlbumsApiFetchAlbumShareRequestParams,
	IAlbumsApiFetchAlbumShareResponseData,
} from './types';

export class AlbumsApi extends BaseApi {

	async fetchAlbum(id: string) {
		return this.get<IAlbumsApiFetchAlbumRequestParams, IAlbumsApiFetchAlbumResponseData>({
			url: getParametrizedUrl(API_URL.ALBUM, { id }),
		});
	}

	async fetchAlbumShare(id: string, { share_auth }: IAlbumsApiFetchAlbumShareRequestParams) {
		return this.get<IAlbumsApiFetchAlbumShareRequestParams, IAlbumsApiFetchAlbumShareResponseData>({
			url: getParametrizedUrl(
				API_URL.ALBUM_SHARE,
				{ id },
				{ share_auth },
			),
		});
	}

}
